import { FC } from "react";

import { Stack, Tooltip, Typography } from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { useTotalInHeaderCalculator } from "../../../../../common/ag-grid/utils/hooks/useTotalInHeaderCalculator.hook";
import type { CustomHeaderProps } from "ag-grid-react";
import {
  ReservationRecommendation,
  SavingsPlanRecommendation,
} from "@/services/cloudchipr.api";
import { TypographyWithTooltip } from "@/components/common/TypographyWithTooltip";
import { money } from "@/utils/numeral/money";

export const CommitmentsEMSHeaderCell: FC<CustomHeaderProps> = (props) => {
  const total = useTotalInHeaderCalculator<
    SavingsPlanRecommendation | ReservationRecommendation
  >(props.api, (data) => data.estimated_monthly_savings, "sum");

  return (
    <Stack position="relative">
      <Stack direction="row" spacing={1} flex={1} justifyContent="flex-end">
        <Typography variant="body2" fontWeight="medium">
          EMS
        </Typography>
        <Tooltip arrow title="Estimated Monthly Savings" placement="top">
          <HelpOutlineIcon
            fontSize="small"
            sx={{ verticalAlign: "middle", ml: 1, color: "info.main" }}
          />
        </Tooltip>
      </Stack>

      <TypographyWithTooltip title={money(total)} variant="caption" />
    </Stack>
  );
};
